module.exports = __webpack_public_path__ + "static/media/998145.1988ef45.png";